import React from 'react';
import DesignPage from '../components/DesignPage';

const About = () => <DesignPage page="about" />;

export default About;
